export class BigWinEvents {
    public static readonly STARTED: symbol = Symbol('__STARTED__');
    public static readonly FINISHED: symbol = Symbol('__FINISHED__');
    public static readonly WIN_METER_FINISHED: symbol = Symbol('__WIN_METER_FINISHED__');
    public static readonly POST_FEATURE_BW_SKIPPED: symbol = Symbol('__SKIPPED__');
}